export class ParceiroEstimativa {
  id: number;
  parceiroId: number;
  estimativaId: number;
  solucao: string;
  descricao: string;
  quantidade: number;
  valor: number;
  dtInclusao?: string;
  dtAlteracao?: string;
  pAdministrativo: number;
  pComissao: number;
  pImposto: number;
  pInvestimento: number;
  pMargemLiquida: number;
}
